import { render, staticRenderFns } from "./BottleList.vue?vue&type=template&id=6d5202d5&scoped=true&"
import script from "./BottleList.vue?vue&type=script&lang=js&"
export * from "./BottleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5202d5",
  null
  
)

export default component.exports